<template>
  <div id="we-third">
    <div class="container" style="margin-bottom: 120px;margin-top: 30px;">
      <div class="row">
        <div class="col-xs-12">
          <h4 style="font-weight: 600;font-size: 30px;margin-bottom: 20px;">
            <span class="brand-red">{{routeInfo.typeEnLabel}}</span> {{routeInfo.heading}}
            <small>{{routeInfo.title}}</small>
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-8" style="width: 760px;">
          <div id="we-third-topb" class="carousel slide">
            <div class="carousel-inner" role="listbox">
              <div class="item" :class="{active: $index === 0}" v-for="item in extension.galleryPictureJson" track-by="$index">
                <img  :src="item.pic">
                <!--<div class="carousel-caption">-->
                  <!--<h4 style="font-weight: 700;text-shadow:0 0 2px rgba(0,0,0,.4);">{{item.title}}</h4>-->
                <!--</div>-->
              </div>
            </div>
            <a class="left carousel-control" href="#we-third-topb" style="height: 80%;" role="button" data-slide="prev">
              <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="right carousel-control" href="#we-third-topb" style="height: 80%;" role="button" data-slide="next">
              <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>

          <div id="section-1" class="row" style="margin-top: 10px;">
            <div class="col-xs-12 scrollspy">
              <ul class="nav nav-tabs" id="v-spy" v-affix offset-top="638">
                <li @click="sensorsTabEvent(routeInfo.introTabTitle)" class="active">
                  <a href="#section-1">{{routeInfo.introTabTitle}}</a></li>
                <li @click="sensorsTabEvent(routeInfo.highlightTabTitle)">
                  <a href="#section-2">{{routeInfo.highlightTabTitle}}</a></li>
                <li @click="sensorsTabEvent(routeInfo.scheduleTabTitle)">
                  <a href="#section-3">{{routeInfo.scheduleTabTitle}}</a></li>

                <li @click="sensorsTabEvent('注意事项')">
                  <a href="#section-5">注意事项</a></li>
                <li @click="sensorsTabEvent('费用说明')">
                  <a href="#section-6">费用说明</a></li>
                <li @click="sensorsTabEvent('活动照片')">
                  <a href="#section-7">活动照片</a></li>
              </ul>
            </div>
          </div>
          <div>
            <div class="row seperation">
              <div class="col-xs-4 line"></div>
              <div class="col-xs-4 text-center">
                <h4 class="brand-red">{{routeInfo.introTabTitle}}</h4></div>
              <div class="col-xs-4 line"></div>
            </div>
            <div class="row">
              <div class="col-xs-12" style="margin-bottom: 20px;" v-html="extension.introduceText">
              </div>
            </div>
          </div>
          <div id="oldlightpot">
           <div class="row seperation" id="section-2">
              <div class="col-xs-4 line"></div>
              <div class="col-xs-4 text-center">
                <h4 class="brand-red">{{routeInfo.highlightTabTitle}}</h4></div>
              <div class="col-xs-4 line"></div>
            </div>
            <div class="row" style="margin-bottom:50px;">
              <div class="col-xs-12">
                <div id="we-third-lightpot" class="carousel slide carousel-fade" data-v-ride="carousel">
                  <ol class="carousel-indicators" style="top: 370px; bottom: initial;">
                    <li data-target="#we-third-top" v-for="item in extension.highlightJson" data-slide-to="{{$index}}" :class="{active: $index === 0}"></li>
                  </ol>
                  <div class="carousel-inner" role="listbox">
                    <div class="item {{ $index === 0 ? 'active' : ''}}" v-for="item in extension.highlightJson" track-by="$index">
                      <img :src="item.pic">
                      <div class="lightpot-detail">
                        <h5>{{item.title}}</h5>
                        <p>{{item.intro}}</p>
                      </div>
                    </div>
                  </div>
                  <a class="left carousel-control" href="#we-third-lightpot" role="button" data-slide="prev">
                    <span class="glyphicon glyphicon-chevron-left d-arrow" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span></a>
                  <a class="right carousel-control" href="#we-third-lightpot" role="button" data-slide="next">
                    <span class="glyphicon glyphicon-chevron-right d-arrow" aria-hidden="true"></span>
                    <span class="sr-only">Next</span></a>
                </div>
              </div>
            </div>
          </div>
          <div id="section-3">
            <div class="row seperation">
              <div class="col-xs-4 line"></div>
              <div class="col-xs-4 text-center">
                <h4 class="brand-red">{{routeInfo.scheduleTabTitle}}</h4></div>
              <div class="col-xs-4 line"></div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <ul class="detail_trip">
                  <li :class="{first: $index === 0}" v-for="item in extension.scheduleJson" track-by="$index">
                    <span class="icon_circle"></span>{{item.intro}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div id="section-4" v-if="extension.sponsorJson.length > 0">
            <div class="row seperation">
              <div class="col-xs-4 line"></div>
              <div class="col-xs-4 text-center">
                <h4 class="brand-red">{{routeInfo.sponsorTabTitle}}</h4>
              </div>
              <div class="col-xs-4 line"></div>
            </div>
            <div class="row" v-for="item in extension.sponsorJson" track-by="$index">
              <div class="col-xs-5">
                <img :src="item.pic" class="img-responsive">
              </div>
              <div class="col-xs-7">
                <h4>{{item.title}}</h4>
                <p class="text-muted">{{item.intro}}</p>
              </div>
            </div>
          </div>
          <div id="section-5">
            <div class="row seperation">
              <div class="col-xs-4 line"></div>
              <div class="col-xs-4 text-center">
                <h4 class="brand-red">注 意 事 项</h4></div>
              <div class="col-xs-4 line"></div>
            </div>
            <div class="row">
              <div class="col-xs-12" v-html="extension.attentionText">
              </div>
            </div>
          </div>
          <div id="section-6">
            <div class="row seperation">
              <div class="col-xs-4 line"></div>
              <div class="col-xs-4 text-center">
                <h4 class="brand-red">费 用 说 明</h4></div>
              <div class="col-xs-4 line"></div>
            </div>
            <div class="row">
              <div class="col-xs-12" v-html="extension.feeIntroText">
              </div>
              <div class="col-xs-12" v-html="extension.refundInfoText">
              </div>
            </div>
          </div>
          <div id="section-7">
            <div class="row seperation">
              <div class="col-xs-4 line"></div>
              <div class="col-xs-4 text-center">
                <h4 class="brand-red">活 动 照 片</h4></div>
              <div class="col-xs-4 line"></div>
            </div>
            <div class="row">
              <div class="col-xs-12" id="fancy">
                <section class="regular" v-slick="extension.bottomPictureJson" v-el:extension.bottomPictureJson>
                  <div v-for="item in extension.bottomPictureJson" track-by="$index" v-fancybox="extension.bottomPictureJson" selector="[js-fancybox]">
                    <a class="fancybox" js-fancybox :href="item.pic" data-fancybox-group="gallery" title="{{item.title}}">
                      <img :src="item.pic">
                    </a>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-4" style="width: 360px;">
          <div class="baoming" v-affix offset-top="218" offset-bottom="440">
            <ul class="list-inline list-choices">
              <li style="margin-bottom: 5px;padding-left: 0;">
                <small>活动日期：</small></li>
              <br>
              <li class="choice text-center " :class="{active: selectedDay === item.startDate}" v-for="item in triplist" track-by="$index" @click="select('date', item)">
                <small>{{ item.startDate.substr(5, 2) }}月</small>
                <br>
                <strong style="font-size: 16px;">{{ item.startDate.substr(8, 2) }}</strong>
                <br>
                <small>{{ item.weekday }}</small>
              </li>
            </ul>
            <div v-for="tritem in triplist">
              <div v-show="selectedDay === tritem.startDate">
                <ul class="list-inline list-choices">
                  <li style="margin-bottom: 5px;padding-left: 0;">
                    <small>时间地点：</small>
                  </li>
                  <br>
                  <li v-for="wditem in tritem.tripWideList" @click="select('trip', wditem)" class="choice" :class="{active: selectedTripId === wditem.id}" style="margin-bottom: 8px;padding:10px 8px; margin-right: 0;">
                    {{ wditem.assemblePlace }} {{ wditem.assembleTime }}
                    <span v-if="wditem.surplusSize < 1">已报满</span>
                    <span v-if="wditem.surplusSize > 0 && wditem.surplusSize < 5">剩余{{ wditem.surplusSize }} 名额</span>
                  </li>
                </ul>
                <ul class="list-inline list-choices">
                  <li style="margin-bottom: 5px;padding-left: 0;">
                    <small>活动价格：</small>
                  </li>
                  <br>
                  <li v-for="wditem in tritem.tripWideList" v-show="selectedTripId === wditem.id">
                    <h4 class="brand-red">
                      {{ wditem.price > 0 ? wditem.price : '免费' }}
                      <span v-for="ruleb in routeInfo.ruleLabels" track-by="$index"  style="font-size: 14px;cursor: pointer;" >
                      <span v-if="ruleb === '全额返现'" @click="gorecomend()">查看全额返现规则</span>
                    </span>
                    </h4>
                    <span v-for="rulela in routeInfo.ruleLabels" track-by="$index" class="ruleb">{{rulela === '新人立减50' ? '新人立减￥50' : rulela}}</span>
                    <span v-for="ruleway in routeInfo.wayLabels" track-by="$index" class="ruleb">{{ruleway}}</span>
                    <span v-for="rulebthe in routeInfo.themeLabels" track-by="$index" class="ruleb">{{rulebthe}}</span>
                  </li>
                </ul>

                <div v-for="wditem in tritem.tripWideList" v-show="selectedTripId === wditem.id">
                  <button v-if="!['TRAVELING', 'CLOSED'].includes(wditem.applyDeadlineStatus) && wditem.surplusSize > 0" class="btn btn-primary btn-block btn-lg" type="button"
                          style="background-color: #E60012;border:1px solid #ddd;" @click="bm()">马上报名</button>
                  <button v-if="wditem.applyDeadlineStatus === 'CLOSED'" class="btn btn-primary btn-block btn-lg"
                          type="button" style="background-color: #E60012;border:1px solid #ddd;" disabled>正在出队</button>
                  <button v-if="wditem.applyDeadlineStatus === 'TRAVELING'" class="btn btn-primary btn-block btn-lg"
                          type="button" style="background-color: #E60012;border:1px solid #ddd;" disabled>截止报名</button>
                  <button v-if="wditem.surplusSize <= 0" class="btn btn-primary btn-block btn-lg" type="button"
                          style="background-color: #E60012;border:1px solid #ddd;" disabled>已报满</button>

                  <ul class="list-unstyled info" style="font-size:13px;margin-top: 30px;">
                    <li style="height: 30px;">
                      <img src="https://dao-library.54traveler.com/dcr-common/age.png" style="width:20px;height:20px;">&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;龄：{{routeInfo.applyAgeRange}}
                    </li>
                    <li style="height: 30px;" v-show="routeInfo.isSchoolAge">
                      <img src="https://dao-library.54traveler.com/dcr-common/age.png" style="width:20px;height:20px;">&nbsp;&nbsp;<span style="color:#E60012;">寒暑假开放18-45岁报名</span>
                    </li>
                    <li style="height: 30px;">
                      <img src="https://dao-library.54traveler.com/dcr-common/time.png" style="width:20px;height:20px;">&nbsp;&nbsp;活动时长： {{routeInfo.durationHours}}小时左右
                    </li>
                    <li style="height: 30px;" v-show="routeInfo.scale">
                      <img src="https://dao-library.54traveler.com/dcr-common/people.png" style="width:20px;height:20px;">&nbsp;&nbsp;团队人数：{{routeInfo.scale}}
                    </li>
                    <li style="height: 30px;" v-if="routeInfo.cultureIndex">
                      <img src="https://dao-library.54traveler.com/dcr-common/icon-cultureStar.png" style="width:20px;height:20px;">&nbsp;&nbsp;文化指数：
                      <span>
                      <img src="https://dao-library.54traveler.com/dcr-common/dao-fill-h.png" style="width:20px;height:20px;"  v-for="item in whfill">
                      <img src="https://dao-library.54traveler.com/dcr-common/dao-half-h.png" style="width:20px;height:20px;"  v-for="item in whhalf">
                      <img src="https://dao-library.54traveler.com/dcr-common/dao-stroke-h.png" style="width:20px;height:20px;"  v-for="item in whempty">
                    </span>
                    </li>
                    <li style="height: 30px;" v-if="routeInfo.physicalIndex">
                      <img src="https://dao-library.54traveler.com/dcr-common/icon-physicalStar.png" style="width:20px;height:20px;">&nbsp;&nbsp;体力指数：
                      <span>
                      <img src="https://dao-library.54traveler.com/dcr-common/dao-fill-h.png" style="width:20px;height:20px;"  v-for="item in fill">
                      <img src="https://dao-library.54traveler.com/dcr-common/dao-half-h.png" style="width:20px;height:20px;"  v-for="item in half">
                      <img src="https://dao-library.54traveler.com/dcr-common/dao-stroke-h.png" style="width:20px;height:20px;"  v-for="item in empty">
                    </span>
                    </li>
                    <li style="height: 30px;">
                      <img src="https://dao-library.54traveler.com/dcr-common/edit-red.png" style="width:20px;height:20px;">&nbsp;&nbsp;关于改签：不支持改签，详情请看费用说明
                    </li>
                    <li style="min-height: 30px;">
                      <img src="https://dao-library.54traveler.com/dcr-common/time.png" style="width:20px;height:20px;">&nbsp;&nbsp;限时优惠：微信关注「开门去玩」公众号，回复「限时福利」即可领取
                    </li>
                  </ul>
                </div>

                <div v-if="extension.cityEpidemicContainmentText" class="cityEpidemicTips">{{extension.cityEpidemicContainmentText}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 疫情弹窗 -->
    <div v-bind:class="{ 'alert' : alertPest, 'noAlert': !alertPest}" role="alert">
      <div class="alertContent">
        <div class="title">温馨提示</div>
        <div class="text-left content">
          <br>
          <b>Hi，为了自身及他人健康，请确认你的个人情况如下：</b>
          <div v-html="alertMessage"></div>
          <br><br>
          <input type="checkbox" name="check" v-model="isChecked" style="font-size: 16px;" />
          <b>我承诺本人以及同行人（如有）符合上述情况，并将配合履行相关防控事宜。</b>
        </div>

        <div class="text-right">
          <button class="btn btn-default" type="button" style="border:1px solid #ddd;" @click="cancelApply()">取消</button>
          <button class="btn btn-primary" type="button" style="background-color: #E60012;border:1px solid #ddd;margin-right: 10px;" @click="goSignUp()">马上报名</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import config from '../libs/config.js'
  import cache from '../libs/cache'

  import $ from 'jquery'
  import 'bootstrap/js/scrollspy'
  // import { find } from 'lodash'

  import Carousel from '../components/Carousel'
  import Slider from '../components/Slider'

  export default {
    components: {
      Carousel,
      Slider
    },
    ready () {
      $('.carousel').carousel()
      $('body').scrollspy({target: '.scrollspy'})
      this.url = window.encodeURIComponent(window.location.href)
    },
    mounted () {
    },
    data () {
      return {
        categories: config.categories,
        route: {
          basic: {}
        },
        routeInfo: [],
        extension: [],
        triplist: [],
        selected: {
          date: '',
          trip: {}
        },
        galleryPictureJson: [
          {
            'pic': '//we-oss.oss-cn-shanghai.aliyuncs.com/2020/8/18cbd0c086eb60c614ac9c43c1f7c24f.jpg',
            'title': ''
          }
        ],
        routeHighlight: [
          {
            'id': 11471,
            'intro': 'Swing Dance（摇摆舞）起源于上世纪20年代，与swing风格的爵士乐共同发展起来，常常出现在纽约黑人居住区的舞厅里。随着大乐队时代的到来，这种舞在年轻人中迅速火爆起来。↵摇摆舞有上千种变化，舞动起来不受任何拘束，可优雅、可俏皮，节奏欢快，跳舞的人脸上总是笑容洋溢😁↵人们常说“摇摆舞是一种，会走路就会跳的舞”，舞蹈自娱性很强。所以在摇摆舞中释放自己，再合适不过啦，摇摆起来！↵',
            'pic': '//we-oss.oss-cn-shanghai.aliyuncs.com/2020/8/2d84f1018c7036bbcbc90e747c8cb415.jpg',
            'routeId': 601,
            'title': ' 1月30日 & 2月16日：Swing（摇摆舞）'
          }
        ],
        routeSchedule: [
          {
            'id': '11855',
            'intro': '10min 集合啦~认识认识今天的新朋友',
            'routeId': '601',
            'sort': '0'
          }
        ],
        routeSponsor: [
          {
            'head': '赞助商',
            'id': 3810,
            'intro': 'Soul City创始人,曾在美国BluesSHOUT、法国Studio Hop Blues week、韩国BlueSweet等各大国际Blues活动中学习，开设了不同级别的课程、舞会和表演。与不同行业的品牌组办跨界活动，Farfetch、CBi桥中品牌咨询、Chair Club蓝调酒吧、Maison Lina Ma、大悦城、CASANOVA、颜局摄影工作室等。↵她希望让越来越多的人，从人与人的相处中，感受到生活的温度。↵',
            'pic': 'https://we-oss.oss-cn-shanghai.aliyuncs.com/2019/11/2465bc1d6aaaa2e755554df7b7d26e10.jpg',
            'routeId': 601,
            'title': 'Jenny 杜 '
          }
        ],
        bottomList: [
          {
            'href': null,
            'id': 16518,
            'pic': 'https://we-oss.oss-cn-shanghai.aliyuncs.com/2020/7/57bc69756eedb7a3b1c8d1926d03bf22.jpg',
            'sliderId': 5646,
            'sort': 0,
            'title': ''
          }
        ],
        orderlist: [],
        tripStatus: config.tripStatus,
        timeSize: null,
        locationSize: 3,
        fill: 0,
        half: 0,
        empty: 0,
        whfill: 0,
        whhalf: 0,
        whempty: 0,
        url: '',
        alertPest: false,
        alertMessage: '',
        refundCanShow: true,
        isChecked: false,
        selectedDay: '',
        selectedTripId: 0,
        selectedOriginalId: 0,
        sensorsSku: {},
        sensorsTrip: {}
      }
    },
    watch: {
      'route.basic.heading' (val) {
        if (val) {
          document.title = val
        }
      }
    },
    methods: {
      gorecomend () {
        var url = '/weRule'
        window.open(url)
      },
      apply (tripId) {
        window.location.href = `${process.env.U_URL}/order/create/W${tripId}`
      },
      sensorsTabEvent (tabName) {
        this.sensorscommon.travelProductDetailsButtonClient(tabName)
      },
      getRoute () {
        return this.$http.get(`${config.apiRoute}/sku-wide/detail?weRouteId=${this.$route.params.id}`, Object.assign({}, this.$route.query))
          .then(({data}) => {
            var routeInfojson = data.data
            this.routeInfo = data.data
            this.extension = routeInfojson.extension
            this.whfill = parseInt(routeInfojson.cultureIndex)
            this.whhalf = (routeInfojson.cultureIndex - this.whfill) * 2
            this.whempty = 5 - this.whfill - this.whhalf
            this.fill = parseInt(routeInfojson.physicalIndex)
            this.half = (routeInfojson.physicalIndex - this.fill) * 2
            this.empty = 5 - this.fill - this.half
            this.torderlist(routeInfojson.id)
            this.sensorsSku = {
              sku_id: data.data.originalId,
              sku_name: data.data.abbreviation,
              business_catalog: data.data.catalog,
              recommend_label: data.data.recommendLabel,
              type_label: data.data.typeZhLabel,
              rule_label: data.data.ruleLabels,
              way_label: data.data.wayLabels,
              theme_label: data.data.themeLabels,
              city: data.data.city,
              trip_hour: data.data.durationHours,
              min_price: data.data.minPrice,
              max_price: data.data.maxPrice
            }
            this.sensorscommon.travelProductDetailsClient(this.sensorsSku)
          })
      },
      torderlist (id) {
        var _this = this
        return this.$http.get(`${config.apiRoute}/trip-wide?pageScene=dayGroup&skuWideId=` + id)
          .then(({data}) => {
            _this.triplist = data.data
            var triplist = data.data
            var index = 0
            triplist.forEach((item) => {
              if (index < 1) {
                _this.selectedDay = item.startDate
                var tindex = 0
                item.tripWideList.forEach((tpitem) => {
                  if (tindex < 1) {
                    _this.selectedTripId = tpitem.id
                    _this.selectedOriginalId = tpitem.originalId
                    this.sensorsTrip = {
                      trip_price: tpitem.price,
                      trip_start_date: tpitem.startDate,
                      trip_end_date: tpitem.endDate,
                      holidays: tpitem.holidays
                    }
                  }
                  tindex++
                })
              }
              index++
            })
          })
      },
      select (type, val) {
        if (type === 'date') {
          let tripWideList = val.tripWideList
          var tindex = 0
          tripWideList.forEach((tpitem) => {
            if (tindex < 1) {
              this.selectedTripId = tpitem.id
              this.selectedOriginalId = tpitem.originalId
            }
            tindex++
          })
          this.selectedDay = val.startDate
        }
        if (type === 'trip') {
          this.selectedTripId = val.id
          this.selectedOriginalId = val.originalId
          this.sensorsTrip = {
            trip_price: val.price,
            trip_start_date: val.startDate,
            trip_end_date: val.endDate,
            holidays: val.holidays
          }
        }
      },
      // 疫情特殊处理
      goSignUp () {
        if (this.isChecked) {
          this.alertPest = false
          this.sensorscommon.layerClickClient(this.sensorsSku, '马上报名')
          window.location.href = `${process.env.U_URL}/order/create/` + this.selectedOriginalId
        } else {
          window.alert('请勾选承诺哟～')
        }
      },
      bm () {
        let self = this
        this.sensorscommon.travelProductSignUpClient(this.sensorsSku, this.sensorsTrip)

        return this.$http.get(`${config.apiRoute}/trip-wide/${this.selectedOriginalId}/apply-message`)
          .then(({data}) => {
            if (data.data.alertMessage) {
              self.alertMessage = data.data.alertMessage
              self.alertPest = true
            } else {
              self.isChecked = true
              self.goSignUp()
            }
          })
      },
      cancelApply () {
        this.alertPest = false
        this.sensorscommon.layerClickClient(this.sensorsSku, '取消')
      }
    },
    filters: {
      oLimitBy (obj, size) {
        if (size === null || size === undefined) {
          return obj
        }
        let result = {}
        Object.keys(obj).slice(0, size).forEach((key) => {
          result[key] = obj[key]
        })
        return result
      }
    },
    route: {
      data () {
        Object.assign(this.$data, cache.get() || {})
        return this.getRoute()
          .then(() => {
            this.$nextTick(() => {
              cache.set(this.$data)
            })
          }, (e) => {
          })
      },
      deactivate (transition) {
        document.title = '稻草人旅行 | 城市玩家'
        transition.next()
      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/third.css';
  /*  .fancybox > img {
      width: 140px;
      height: 150px;
    }*/
  .choice {
    cursor: pointer;
  }
  .choice.active {
    border-color: #E60012 !important;
    color: #E60012 !important;
  }
  .share {
    display: inline-block;
    margin-left: 20px;
    vertical-align: bottom;
  }
  .container{
    width: 1120px;
  }
  /*---- top nav-tabs ----*/
  .nav-tabs{
    background: #fff;
    border-bottom: 1px dotted #E60012;
    z-index: 1000;
  }
  .nav-tabs>li{
    width: 16.66%;
    text-align: center;
  }
  .nav-tabs>li>a{
    color:#888;
    font-size: 16px;
    font-weight: bold;
    border-radius: 0;
    padding-bottom: 7px;
  }
  .nav>li>a:hover, .nav>li>a:focus{
    background-color: #fff;
    border: none;
    border-top: 1px dotted transparent;
    color: #E60012;
  }
  .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover{
    border: none;
    color: #E60012;
    border-bottom: 4px solid #E60012;
  }
  .share {
    vertical-align: baseline;
  }
  .d-arrow {
    top: 180px;
  }
  .time-more {
    height: 57px;
    line-height: 57px !important;
    vertical-align: top;
  }
  .d-subtitle {
    color: #E60012;
    font-weight: bold;
  }
  .d-list {
    padding-left: 0px;
    list-style-position: inside;
  }
  .alert {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    z-index: 2000;
    text-align: center;
  }
  .noAlert {
    display: none;
  }
  .alertContent {
    width: 50%;
    min-height: 200px;
    max-height: 700px;
    overflow-y: scroll;
    background: #FFF;
    margin: 4em auto;
    border-radius: 5px;
    padding-bottom: 1em;
  }
  .alertContent .title {
    background: #E60012;
    width: 100%;
    border-radius: 5px 5px 0 0;
    color: #FFF;
    font-weight: bolder;
    font-size: 18px;
    padding: .5em;
  }
  .alertContent .content {
    width: 80%;
    margin: 10px auto;
  }
  .ruleb {
    display: inline-block;
    background: #F4F4F4;
    padding: 5px 10px;
    margin: 5px 5px 5px 0;
    font-size: 12px;
    color: #E60012;
    border-radius: 3px;
    border: 1px solid #f4f4f4;
  }
  .cityEpidemicTips {
    padding: 10px 8px;
    font-size: 13px;
    margin-top: 10px;
    line-height: 1.5;
    background: #fdf6ec;
    color: #e6a23c;
    border-radius: 5px;
  }
</style>



/** WEBPACK FOOTER **
 ** Third.vue?88979f30
 **/